import { useState } from "react";
import Header from "@/components/Header";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import { useLanguage } from "@/contexts/LanguageContext";
import { Button } from "@/components/ui/button";
import { Play, Target, TrendingUp, Zap } from "lucide-react";
const Reklamfilm = () => {
  const {
    language,
    setLanguage,
    content: currentContent
  } = useLanguage();
  return <div className="min-h-screen bg-background">
      <Header language={language} onLanguageChange={setLanguage} content={currentContent.header} />
      
      <main className="pt-20">
        {/* Hero Section */}
        <section className="py-20 px-4">
          <div className="container mx-auto max-w-4xl text-center">
            <h1 className="text-4xl md:text-6xl font-bold mb-6">
              <span className="hero-text">Reklamfilm som konverterar</span>
            </h1>
            <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto mb-8">Efter 15 år av videomarknadsföring vet vi att det krävs mer än bara &quot;en perfekt reklamfilm&quot; för att lyckas med en kampanj. Vår AI-hybridstudio gör det lätt att skapa varianter och olika format med snabba leveranser &amp; låga kostnader.</p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button asChild variant="default" size="lg" className="bg-gradient-primary border-0 hover:opacity-90">
                <a href="https://volym.typeform.com/to/vvm1IndH?utm_source=xxxxx&utm_campaign=xxxxx&utm_content=xxxxx" target="_self">
                  Få prisförslag
                </a>
              </Button>
            </div>
          </div>
        </section>

        {/* Features Section */}
        <section className="py-20 px-4 bg-secondary/30">
          <div className="container mx-auto max-w-6xl">
            <div className="grid md:grid-cols-3 gap-8">
              <div className="text-center p-6">
                <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mx-auto mb-4">
                  <Target className="w-6 h-6 text-primary" />
                </div>
                <h3 className="text-xl font-semibold mb-3">Målgruppsanpassning</h3>
                <p className="text-muted-foreground">
                  AI analyserar din målgrupp och skapar innehåll som resonerar med rätt personer.
                </p>
              </div>
              <div className="text-center p-6">
                <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mx-auto mb-4">
                  <TrendingUp className="w-6 h-6 text-primary" />
                </div>
                <h3 className="text-xl font-semibold mb-3">Optimerad konvertering</h3>
                <p className="text-muted-foreground">
                  Videor designade för att maximera klick, engagemang och konverteringar.
                </p>
              </div>
              <div className="text-center p-6">
                <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mx-auto mb-4">
                  <Zap className="w-6 h-6 text-primary" />
                </div>
                <h3 className="text-xl font-semibold mb-3">Snabb leverans</h3>
                <p className="text-muted-foreground">
                  Från idé till färdig videoannons på 2-5 dagar. Perfekt för snabba kampanjer.
                </p>
              </div>
            </div>
          </div>
        </section>


        <ContactSection content={currentContent.contact} />
      </main>
      
      <Footer content={{
      company: "Volym Digitalbyrå AB",
      rights: language === "sv" ? "Alla rättigheter förbehållna." : "All rights reserved."
    }} />
    </div>;
};
export default Reklamfilm;